import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import { Link, useLocation } from 'app/src/utils/routing';

export const Container = styled(View)`
  flex-direction: row;
  background-color: maroon;
  padding: 10px;
  justify-content: space-between;
  height: 40px;
  z-index: 999;
`;

export const Items = styled(View)`
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

export const Label = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: white;
`;

export const ITEMS = [
  {
    path: '/mcadmin/users',
    label: 'Email Users',
  },
  {
    path: '/mcadmin/forwards',
    label: 'Email Forwards',
  },
  {
    path: '/mcadmin/projects',
    label: 'MC Projects',
  },
];

const Menu = () => {
  const location = useLocation();

  if (location.pathname.endsWith('change-password')) {
    return null;
  }

  return (
    <Container>
      <Items>
        {ITEMS.map(({ label, path }) => (
          <Link key={label} to={`/pti${path}`}>
            <Label>{label}</Label>
          </Link>
        ))}
      </Items>
    </Container>
  );
};

export default Menu;
